import { IChangeDateRenderedAction } from '../../../actions/bookingCalendar/date/changeDateRange'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IChangeDateRenderedAction,
): IBookingCalendarStore {
  return {
    ...state,
    dates: {
      ...state.dates,
      manual: action.isManual ? action.startDate : null,
      rendered: {
        from: action.startDate,
        to: action.finishDate,
      },
    },
  }
}
